import * as React from 'react';

/**
 * @deprecated Use the MUI SVG icon instead! See https://github.com/tocktix/admin/wiki/Svg-Icons-Components for details.
 **/
const SvgIconTagKey = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" {...props}>
    <path
      clipRule="evenodd"
      d="M4.5 14.803a1.066 1.066 0 1 0 0-2.132 1.066 1.066 0 0 0 0 2.132z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M15.157.947l-6.95 6.951a4.974 4.974 0 1 0 2.131 2.132l2.332-2.333h1.066V6.631l.355-.355h1.066V5.21l.355-.355h1.066V3.79l.71-.71V.947h-2.13z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTagKey;
